module.exports = __webpack_public_path__ + "static/media/tananyagok.e5e5ff18.png";